module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.9d1a6cb872163b266198.js");
}
